import { render, staticRenderFns } from "./closeBusiness.vue?vue&type=template&id=4f844c3c&scoped=true&"
import script from "./closeBusiness.vue?vue&type=script&lang=js&"
export * from "./closeBusiness.vue?vue&type=script&lang=js&"
import style0 from "./closeBusiness.vue?vue&type=style&index=0&id=4f844c3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f844c3c",
  null
  
)

export default component.exports